export default "__VITE_ASSET__DXBf0mol__"